<template>
  <table>
    <slot></slot>
  </table>
</template>

<script>
import { onMounted, reactive, useSlots } from "vue";
export default {
  props: {
    model: Object,
  },
  setup() {
    const state = reactive({});
    onMounted(() => {
      state.slots = useSlots();

      //   state.keys = Object.keys(props.model);
      //   state.rows = state.keys.length;
    });
    return { state };
  },
};
</script>
<style scoped></style>
